import React from "react";
import { Styles } from "./styles";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
} from "chart.js";

// Register the required Chart.js components
ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);

const PaymentStatus = ({ paymentsStatusStats }) => {
  // Map the API data to the chart data format
  const labelsMap = {
    cancel: "Cancel",
    paid: "Paid",
    pending: "Pending",
  };

  // Generate labels and data dynamically
  const labels = paymentsStatusStats.map(
    (stat) => labelsMap[stat.status_payment] || stat.status_payment
  );
  const dataCount = paymentsStatusStats.map((stat) => stat.total);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Payment status Statistics",
        data: dataCount,
        backgroundColor: ["#114787", "#d71814", "#58A4B0"],
        borderColor: ["#114787", "#d71814", "#58A4B0"],
        borderWidth: 1,
      },
    ],
  };

  // Options for the Bar Chart
  const options = {
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <Styles>
      <div
        style={{
          width: "300px",
          height: "300px",
          margin: "0 auto",
          marginTop: "20px",
        }}
      >
        <div className="title mb-2">{data?.datasets[0]?.label}</div>
        <Bar data={data} options={options} />
      </div>
    </Styles>
  );
};

export default PaymentStatus;
